import { auth } from "../firebase";
import { isListNotEmpty, isNotNullOrUndefined, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import moment from 'moment-timezone';

class ValueHistory {
    value = null;
    by = isObjectNotEmpty(auth.currentUser) ? auth.currentUser.uid : 'SYSTEM';
    at = moment().utc().toDate();

    constructor(valueHistory) {
        if (isObjectNotEmpty(valueHistory)) {
            if (isStringNotEmpty(valueHistory.value)) { this.value = valueHistory.value; }
            if (isStringNotEmpty(valueHistory.by)) { this.by = valueHistory.by; }
            if (isNotNullOrUndefined(valueHistory.at)) { this.at = valueHistory.at; }
        }
    }

    toDto = () => {
        return {
            value: this.value,
            by: this.by,
            at: this.at,
        };
    }

    static addNewValue = (newValue = "", valueHistories = [], at = null, by = null) => {
        let newValueHistory = new ValueHistory({ value: newValue, at: at, by: by }).toDto();
        if (isListNotEmpty(valueHistories)) {
            return [...valueHistories, newValueHistory];
        } else {
            return [newValueHistory];
        }
    }

    // keeps the most recent entries; guards the user doc against unbounded array growth
    static maxHistoryLength = 100;

    static capLength = (valueHistories = [], maxLength = ValueHistory.maxHistoryLength) => {
        if (isListNotEmpty(valueHistories) && valueHistories.length > maxLength) {
            return valueHistories.slice(valueHistories.length - maxLength);
        }
        return valueHistories;
    }

};

export default ValueHistory;